import React from "react";

import { Helpers } from "../../config/Helpers";
import {ReactSession} from "react-client-session";
import {decode as base64_decode, encode as base64_encode} from "base-64";
import {toast} from "react-toastify";
import $ from "jquery";
import PasswordStrengthBar from 'react-password-strength-bar';

class Profile extends React.Component {

    constructor(props) {
        super(props);
        ReactSession.setStoreType("localStorage");
        this.state = {
            sessUserCode: (ReactSession.get("sess_usercode")) ? ReactSession.get("sess_usercode") : '',
            sessEmail: (ReactSession.get("sess_email")) ? ReactSession.get("sess_email") : '',
            sessKodeNasabah: (ReactSession.get("sess_kodenasabah")) ? ReactSession.get("sess_kodenasabah") : '',
            summaryData: '',
            profileData: '',
            bankData: [],
            fullname: '',
            handphone: '',
            alamat: '',
            bank: '',
            pemilik: '',
            rekening: '',
            secureTextOld: true,
            secureTextNew: true,
            secureTextConfirm: true,
            activeView: 'dashboard' // dashboard | editProfile | changePassword
        }
    }

    componentDidMount() {
        if(!this.state.sessUserCode){
            window.location.href = './login?redirectUrl=' + base64_encode(window.location.href);
        }else{
            this.getSummary();
            this.getAccountInfo();
            this.getBank();
        }
    }

    getSummary = () => {
        Helpers.getSummary(this.state.sessUserCode, this.state.sessKodeNasabah).then(res => {
            this.setState({
                summaryData: res[0]
            });
        })
    };

    getBank = () => {
        Helpers.getBank().then(res => {
            this.setState({
                bankData: res
            });
        })
    };

    getAccountInfo = () => {
        Helpers.getAccountInfo(this.state.sessEmail).then(res => {
            if(!res || res.length === 0){
                return;
            }

            this.setState({
                profileData: res[0],
                fullname: res[0].NamaMarketing,
                handphone: res[0].Telepon,
                alamat: res[0].Alamat,
                bank: res[0].KodeBank,
                pemilik: res[0].NamaRekening,
                rekening: res[0].NoRekening
            });
        })
    };

    viewPassword = (state) => {
        this.setState({[state]: !this.state[state]});
    };

    showView = (view) => {
        this.setState({ activeView: view });
    };

    handleSubmit = (e) => {
        e.preventDefault();

        let error = false;
        let message = '';
        if (this.state.new.length < 8) {
            message += "Your password needs a minimum of eight characters. ";
            error = true;
        }
        if (this.state.new.search(/[a-z]/) == -1) {
            message += "Your password needs at least one lower case letter. ";
            error = true;
        }
        if (this.state.new.search(/[A-Z]/) == -1) {
            message += "Your password needs at least one upper case letter. ";
            error = true;
        }
        if (this.state.new.search(/[0-9]/) == -1) {
            message += "Your password needs at least one number. ";
            error = true;
        }
        if (this.state.new.search(/[!@#$%^&*]/) == -1) {
            message += "Your password needs at least one symbol. ";
            error = true;
        }
        if (error) {
            toast.error(message);
            return;
        }

        Helpers.changePassword(this.state.sessUserCode, this.state.old, this.state.new, this.state.confirm).then(res => {
            if(res.length > 0){
                if(res[0].alert == 'success'){
                    this.setState({
                        old: '',
                        new: '',
                        confirm: '',
                        activeView: 'dashboard'
                    });
                }

                toast[res[0].alert](res[0].message);
            }else{
                toast.error(Helpers.MSG_ERROR);
            }
        })
    };

    handleSubmitProfile = (e) => {
        e.preventDefault();

        Helpers.updateProfileMarketing(
            this.state.sessUserCode,
            this.state.fullname,
            this.state.alamat,
            this.state.handphone,
            this.state.sessEmail,
            this.state.bank,
            this.state.pemilik,
            this.state.rekening,
            this.state.sessEmail
        ).then(res => {
            if(res.length > 0){
                if(res[0].alert == 'success'){
                    this.setState({
                        summaryData: '',
                        profileData: '',
                        bankData: [],
                        fullname: '',
                        handphone: '',
                        alamat: '',
                        bank: '',
                        pemilik: '',
                        rekening: '',
                        activeView: 'dashboard'
                    });

                    this.getSummary();
                    this.getAccountInfo();
                    this.getBank();
                }

                toast[res[0].alert](res[0].message);
            }else{
                toast.error(Helpers.MSG_ERROR);
            }
        })
    };

    handleBBXPoinLogout = () => {
        if (window.confirm('Apakah anda yakin akan keluar dari BBX Akun?')) {
            ReactSession.set("sess_kodenasabah", '');

            window.location.reload();
        } else {
            console.log('Cancel.');
        }
    };

    handleLogout = () => {
        if (window.confirm('Apakah anda yakin akan keluar dari akun ini?')) {
            ReactSession.set("sess_usercode", '');
            ReactSession.set("sess_email", '');
            ReactSession.set("sess_fullname", '');
            ReactSession.set("sess_kodenasabah", '');

            window.location.href = './login';
        }
    };

    renderDashboard = () => {
        const { summaryData, profileData, sessEmail } = this.state;

        return (
            <>
                {/* ===== Profile Header (orange) ===== */}
                <section className="account-profile-header">
                    <div className="account-profile-row">
                        <div className="account-profile-avatar">
                            <i className="fi-rs-user"></i>
                        </div>
                        <div className="account-profile-info">
                            <h3 className="account-profile-name">{(profileData && profileData.NamaMarketing) || '-'}</h3>
                            <p className="account-profile-sub">{(profileData && profileData.Telepon) || '-'}</p>
                            <p className="account-profile-sub">{sessEmail}</p>
                        </div>
                        <button
                            type="button"
                            className="account-profile-edit-btn"
                            onClick={() => {this.showView('editProfile')}}
                        >
                            <i className="fi-rs-pencil"></i>
                        </button>
                    </div>

                    <div className="account-saldo-title-row">
                        <span>Saldo &amp; Poin</span>
                        <a href="./account-balance">Lihat Semua</a>
                    </div>

                    <div className="account-saldo-cards">
                        <a href="./account-mutasi-voucher" className="account-saldo-card">
                            <img src="./assets/imgs/icon/balance/ic_voucher.png" alt="Voucher" className="account-saldo-icon"/>
                            <div className="account-saldo-value">{(summaryData && summaryData.saldo_waroq) || '0'}</div>
                            <div className="account-saldo-label">Voucher Waroq</div>
                        </a>
                        <a href="./account-mutasi-komisi" className="account-saldo-card">
                            <img src="./assets/imgs/icon/balance/ic_coin.png" alt="Poin" className="account-saldo-icon"/>
                            <div className="account-saldo-value">{(summaryData && summaryData.commission_now) || '0'}</div>
                            <div className="account-saldo-label">Waroq Poin</div>
                        </a>
                        <a href="./account-mutasi-limit" className="account-saldo-card">
                            <img src="./assets/imgs/icon/balance/ic_limit.png" alt="Limit Kredit" className="account-saldo-icon"/>
                            <div className="account-saldo-value">{(summaryData && summaryData.credit_limit) || '0'}</div>
                            <div className="account-saldo-label">Limit Kredit</div>
                        </a>
                    </div>
                </section>

                {/* ===== Menu List ===== */}
                <section className="account-menu-card">
                    <a href="./location" className="account-menu-item">
                        <div className="account-menu-icon">
                            <i className="fi-rs-marker"></i>
                        </div>
                        <div className="account-menu-text">
                            <h4>Daftar Alamat</h4>
                            <p>Atur alamat pengiriman belanja anda</p>
                        </div>
                        <i className="fi-rs-angle-small-right account-menu-chevron"></i>
                    </a>

                    <a href="./collective-payment" className="account-menu-item">
                        <div className="account-menu-icon">
                            <i className="fi-rs-credit-card"></i>
                        </div>
                        <div className="account-menu-text">
                            <h4>Pembayaran Kolektif</h4>
                            <p>Kelola pesanan menjadi satu pembayaran</p>
                        </div>
                        <i className="fi-rs-angle-small-right account-menu-chevron"></i>
                    </a>

                    <a href="./store" className="account-menu-item">
                        <div className="account-menu-icon">
                            <i className="fi-rs-shop"></i>
                        </div>
                        <div className="account-menu-text">
                            <h4>Mitra</h4>
                            <p>Daftarkan dan kelola mitra belanja anda</p>
                        </div>
                        <i className="fi-rs-angle-small-right account-menu-chevron"></i>
                    </a>

                    <a
                        href="javascript:void(0);"
                        className="account-menu-item"
                        onClick={() => {this.showView('changePassword')}}
                    >
                        <div className="account-menu-icon">
                            <i className="fi-rs-lock"></i>
                        </div>
                        <div className="account-menu-text">
                            <h4>Ubah Kata Sandi</h4>
                            <p>Kelola kata sandi secara berkala</p>
                        </div>
                        <i className="fi-rs-angle-small-right account-menu-chevron"></i>
                    </a>
                </section>

                {/* ===== Logout ===== */}
                <section className="account-logout-card">
                    <a
                        href="./vendor/dashboard"
                        className="account-menu-item"
                    >
                        <div className="account-menu-icon">
                            <i className="fi-rs-lock"></i>
                        </div>
                        <div className="account-menu-text">
                            <h4>Beralih ke Tampilan Vendor</h4>
                            <p>Masuk ke menu vendor untuk mengelola transaksi dan produk anda</p>
                        </div>
                        <i className="fi-rs-angle-small-right account-menu-chevron"></i>
                    </a>

                    <a href="javascript:void(0);" className="account-logout-item" onClick={() => {this.handleLogout()}}>
                        <div className="account-logout-icon">
                            <i className="fi-rs-sign-out"></i>
                        </div>
                        <div className="account-logout-text">Keluar</div>
                        <span className="account-version-badge">Versi 2.7</span>
                    </a>
                </section>
            </>
        );
    };

    renderEditProfile = () => {
        return (
            <section className="account-subpage-card mt-15 mb-15">
                <div className="account-subpage-header">
                    <button type="button" className="account-back-btn" onClick={() => {this.showView('dashboard')}}>
                        <i className="fi-rs-arrow-small-left"></i>
                    </button>
                    <h3>Ubah Profil</h3>
                </div>
                <div className="account-subpage-body">
                    <p className="account-subpage-hint">Pastikan untuk mengisi data dengan benar sebelum melakukan submit.</p>
                    <form className="contact-form-style mt-30 mb-30" method="post" onSubmit={(e) => {this.handleSubmitProfile(e)}}>
                        <div className="input-style mb-20">
                            <label>Nama Lengkap</label>
                            <input value={this.state.fullname} onChange={e => this.setState({fullname: e.target.value})}
                                   placeholder="Masukkan Nama"
                                   type="text" required/>
                        </div>
                        <div className="input-style mb-20">
                            <label>Nomor Handphone</label>
                            <input value={this.state.handphone} onChange={e => this.setState({handphone: e.target.value})}
                                   min={0}
                                   placeholder="Masukkan Nomor Handphone"
                                   type="number" required/>
                        </div>
                        <div className="input-style mb-20">
                            <label>Alamat</label>
                            <input value={this.state.alamat} onChange={e => this.setState({alamat: e.target.value})}
                                   placeholder="Masukkan Alamat"
                                   type="text" required/>
                        </div>
                        <div className="input-style mb-20">
                            <label>Email</label>
                            <input value={this.state.sessEmail}
                                   placeholder="Masukkan Email"
                                   type="email" readOnly={true}/>
                        </div>
                        <div className="input-style mb-20">
                            <label>Nama Bank</label>
                            <div className="custom_select">
                                <select
                                    className="select-style" required onChange={e => this.setState({bank: e.target.value})}>
                                    <option value={''}>Pilih Bank</option>
                                    {
                                        this.state.bankData.map((object, i) => {
                                            return <option key={i} value={object.KodeBank} selected={(this.state.bank == object.KodeBank) ? 'selected' : ''}>{object.Fullname}</option>
                                        })
                                    }
                                </select>
                            </div>
                        </div>
                        <div className="input-style mb-20">
                            <label>Nama Pemilik Rekening</label>
                            <input value={this.state.pemilik} onChange={e => this.setState({pemilik: e.target.value})}
                                   placeholder="Masukkan Nama Pemilik Rekening"
                                   type="text" required/>
                        </div>
                        <div className="input-style mb-20">
                            <label>Nomor Rekening</label>
                            <input value={this.state.rekening} onChange={e => this.setState({rekening: e.target.value})}
                                   min={0}
                                   placeholder="Masukkan Nomor Rekening"
                                   type="number" required/>
                        </div>
                        <button className="submit submit-auto-width" type="submit">Submit</button>
                    </form>
                </div>
            </section>
        );
    };

    renderChangePassword = () => {
        return (
            <section className="account-subpage-card">
                <div className="account-subpage-header">
                    <button type="button" className="account-back-btn" onClick={() => {this.showView('dashboard')}}>
                        <i className="fi-rs-arrow-small-left"></i>
                    </button>
                    <h3>Ubah Kata Sandi</h3>
                </div>
                <div className="account-subpage-body">
                    <div className="auth-hero-icon auth-hero-icon-inline">
                        <i className="fi-rs-shield-check"></i>
                    </div>
                    <p className="account-subpage-hint">Perbarui kata sandi secara berkala agar akunmu tetap aman.</p>

                    <form method="post" onSubmit={(e) => {this.handleSubmit(e)}}>
                        <div className="auth-input-group mb-15">
                            <i className="fi-rs-lock auth-input-icon"></i>
                            <input value={this.state.old} onChange={e => this.setState({old: e.target.value})}
                                   placeholder="Password Lama"
                                   type={(this.state.secureTextOld) ? 'password' : 'text'} required/>
                            <i className={'fi-rs-' + (this.state.secureTextOld ? 'eye' : 'eye-crossed') + ' auth-input-icon-right'} onClick={() => {this.viewPassword('secureTextOld')}}></i>
                        </div>

                        <div className="auth-input-group mb-10">
                            <i className="fi-rs-lock auth-input-icon"></i>
                            <input value={this.state.new} onChange={e => this.setState({new: e.target.value})}
                                   placeholder="Password Baru"
                                   type={(this.state.secureTextNew) ? 'password' : 'text'} required/>
                            <i className={'fi-rs-' + (this.state.secureTextNew ? 'eye' : 'eye-crossed') + ' auth-input-icon-right'} onClick={() => {this.viewPassword('secureTextNew')}}></i>
                        </div>
                        <div className="auth-strength-bar mb-15">
                            <PasswordStrengthBar password={this.state.new} />
                            <small className="auth-hint">Minimal 8 karakter, kombinasi huruf besar, kecil, angka, dan simbol.</small>
                        </div>

                        <div className="auth-input-group mb-20">
                            <i className="fi-rs-lock auth-input-icon"></i>
                            <input value={this.state.confirm} onChange={e => this.setState({confirm: e.target.value})}
                                   placeholder="Ulangi Password Baru"
                                   type={(this.state.secureTextConfirm) ? 'password' : 'text'} required/>
                            <i className={'fi-rs-' + (this.state.secureTextConfirm ? 'eye' : 'eye-crossed') + ' auth-input-icon-right'} onClick={() => {this.viewPassword('secureTextConfirm')}}></i>
                        </div>

                        <button type="submit" className="auth-btn-primary">Simpan</button>
                    </form>
                </div>
            </section>
        );
    };

    render() {
        const { activeView } = this.state;

        return (
            <>
                <main className="main pages mb-80">
                    <div className="account-page-wrap">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6 col-md-8 m-auto">
                                    {activeView === 'dashboard' && this.renderDashboard()}
                                    {activeView === 'editProfile' && this.renderEditProfile()}
                                    {activeView === 'changePassword' && this.renderChangePassword()}
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </>
        );
    }
}

export default Profile;